<template>
  <el-dialog
    v-el-drag-dialog
    custom-class="charge-selector-dialog"
    :visible.sync="innerVisible"
    :title="title"
    width="870px"
    :close-on-click-modal="false"
  >
    <el-scrollbar style="height:60vh;width:auto;" :native="true">
      <!--  todo: config-module  -->
      <search-item
        ref="searchItem"
        :show-more-scheme="true"
        :show-simple="true"
        :expand-adv="true"
        sim-url=""
        adv-url=""
        search-item-code="开票"
        search-item-mode="querydata"
        config-module="800"
      >
        <template v-if="paramsFinal.mode === 1" v-slot:searchAreaHeader>
          <div class="app-main-inner-row" style="background: #eaeaea">
            <el-form ref="basicForm" :inline="true" label-position="left" label-width="60px">
              <el-form-item label="查询方式" class="dense-radio-group">
                <el-radio-group v-model="searchConditions.queryMode">
                  <el-radio :label="1">按费用</el-radio>
                  <el-radio :label="2">按业务</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label-width="0px">
                <el-checkbox>包含应收</el-checkbox>
              </el-form-item>
              <el-form-item label-width="0">
                <span style="color: darkred;">注：此界面已过滤掉完全核销的费用业务</span>
              </el-form-item>
            </el-form>
          </div>
        </template>
      </search-item>
      <div class="app-main-inner-row row-grid" style="min-height: 180px;">
        <cargo-ag-grid
          v-if="searchConditions.queryMode===1"
          key="190802"
          config-module="190802"
          :grid-params.sync="chargeGrid.gridParams"
          :grid-options="chargeGrid.gridOptions"
          :column-defs="chargeGrid.columnDefs"
          :row-data="chargeGrid.rowData"
        />
        <cargo-ag-grid
          v-if="searchConditions.queryMode===2"
          key="190803"
          config-module="190803"
          :grid-params.sync="jobGrid.gridParams"
          :grid-options="jobGrid.gridOptions"
          :column-defs="jobGrid.columnDefs"
          :row-data="jobGrid.rowData"
        />
      </div>
      <div class="app-main-inner-row row-pagination-right" style="padding: 0 10px;">
        <cargo-pagination
          :total="searchConditions.total"
          :page.sync="searchConditions.pageNum"
          :limit.sync="searchConditions.pageSize"
          @pagination="fetchData"
        />
        <div class="total-detail-popover">
          <span><b>USD:</b></span>
          <span><u>666666</u></span>
          <span><b>RMB:</b></span>
          <span><u>666666</u></span>
          <span><b>折合RMB:</b></span>
          <span><u>666666</u></span>
        </div>
      </div>
    </el-scrollbar>

    <div slot="footer">
      <el-button v-if="paramsFinal.mode === 0" type="primary" @click="confirm">确认</el-button>
      <el-button v-if="paramsFinal.mode === 1" type="primary" @click="toNext">下一步</el-button>
      <el-button @click="innerVisible = false">取消</el-button>
    </div>
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
  </el-dialog>
</template>

<script>
import { DocumentManage } from '@/utils/commonUtil'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { getGridSelected, getGridSelectedIds } from '@/utils/agGrid'

export default {
  name: 'ChargeSelectorDialog',
  components: { searchItem, cargoTemplateSelectorDialog },
  props: {
    visible: { type: Boolean, required: true },
    /**
     * params.mode: 弹窗模式[default:0]
     *    0-选择费用
     *    1-创建付款申请-选择费用
     */
    params: { type: Object, required: false }
  },
  data() {
    return {
      innerVisible: false,
      documentManage: new DocumentManage(),
      searchConditions: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        queryMode: 1
      },
      chargeGrid: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false
        },
        columnDefs: [
          {
            headerName: '', width: 55, checkboxSelection: true,
            sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true
          },
          {
            headerName: '业务编号',
            field: 'job_jobNo',
            cellRenderer: params => {
              const methodPath = this.documentManage.getPath('toSearchTemplate')
              return `<a href="/" style="color:#0052cc;">${params.value}</a>
                <i class="el-icon-search" onclick="${methodPath}('${params.data.jobNo}')" style="color:#46a6ff;cursor:pointer"/>`
            }
          },
          {
            headerName: '进仓编号',
            field: 'job_warehouseNo'
          },
          {
            headerName: '订舱编号',
            field: 'job_bookingNo'
          },
          {
            headerName: '截单日期',
            field: 'job_fileCutoff'
          },
          {
            headerName: '项目编号',
            field: 'job_PONO'
          },
          {
            headerName: 'SONO',
            field: 'job_soNo'
          },
          {
            headerName: '箱号',
            field: 'job_containerNo'
          },
          {
            headerName: '海外客服',
            field: 'job_overseaOp'
          },
          {
            headerName: '付款申请单号',
            field: 'billPayment_billPaymentNo'
          },
          {
            headerName: 'ETA',
            field: 'job_ETA'
          },
          {
            headerName: 'ETD',
            field: 'job_ETD'
          },
          {
            headerName: '账单号',
            field: 'billing_billingNo'
          },
          {
            headerName: '结算对象',
            field: 'charge_accountId'
          },
          {
            headerName: '揽货类型',
            field: 'job_cargoSource'
          },
          {
            headerName: '主单号',
            field: 'job_mbl'
          },
          {
            headerName: '分单号',
            field: 'job_import_hbl'
          },
          {
            headerName: '委托单位',
            field: 'job_customerId'
          },
          {
            headerName: '业务类型',
            field: 'job_lob'
          },
          {
            headerName: '业务日期',
            field: 'job_businessDate'
          },
          {
            headerName: '船名航次',
            field: 'job_vesselFlight'
          },
          {
            headerName: '起运港',
            field: 'job_loadingPortCode'
          },
          {
            headerName: '目的港',
            field: 'job_destinationPortCode'
          },
          {
            headerName: '始发站',
            field: 'job_departureStation'
          },
          {
            headerName: '目的站',
            field: 'job_destinationStation'
          },
          {
            headerName: '过境站',
            field: 'job_transitStation'
          },
          {
            headerName: '目的港代理',
            field: 'job_destinationAgent'
          },
          {
            headerName: '销售',
            field: 'job_sales'
          },
          {
            headerName: '操作',
            field: 'job_op'
          },
          {
            headerName: '客服',
            field: 'job_csr'
          },
          {
            headerName: '单证',
            field: 'job_dc'
          },
          {
            headerName: '业务参考号',
            field: 'job_customerRefNo'
          },
          {
            headerName: '自定义业务类型',
            field: 'job_customJobType'
          },
          {
            headerName: '已计提',
            field: 'job_provisioned'
          },
          {
            headerName: '财务日期',
            field: 'charge_accountingDate'
          },
          {
            headerName: '国内/国外',
            field: 'charge_oversea'
          },
          {
            headerName: '收支类型',
            field: 'charge_receivable'
          },
          {
            headerName: '费用状态',
            field: 'charge_chargeState'
          },
          {
            headerName: '审核人',
            field: 'charge_auditor'
          },
          {
            headerName: '确认状态',
            field: 'charge_confirmState'
          },
          {
            headerName: '费用名称',
            field: 'charge_chargeItemId'
          },
          {
            headerName: '单位',
            field: 'charge_measure'
          },
          {
            headerName: '币种',
            field: 'charge_currency'
          },
          {
            headerName: '数量',
            field: 'charge_quantity'
          },
          {
            headerName: '单价',
            field: 'charge_unitRate'
          },
          {
            headerName: '含税价',
            field: 'charge_amount'
          },
          {
            headerName: '不含税价',
            field: 'charge_excludingTaxAmount'
          },
          {
            headerName: '税额',
            field: 'charge_taxAmount'
          },
          {
            headerName: '税率',
            field: 'charge_taxRate'
          },
          {
            headerName: '核销金额',
            field: 'charge_verifiedAmount'
          },
          {
            headerName: '未销金额',
            field: 'charge_unverifiedAmount'
          },
          {
            headerName: '联系人',
            field: 'charge_contactPerson'
          },
          {
            headerName: '创建人',
            field: 'charge_createdBy'
          },
          {
            headerName: '创建日期',
            field: 'charge_dateCreated'
          },
          {
            headerName: '备注',
            field: 'charge_remarks'
          },
          {
            headerName: '往来关联号',
            field: 'job_relatedJob'
          },
          {
            headerName: '委托关联号',
            field: 'job_trustFromJob'
          },
          {
            headerName: '承运人',
            field: 'job_carrierId'
          },
          {
            headerName: '确认日期',
            field: 'charge_confirmDate'
          },
          {
            headerName: '费用确认人',
            field: 'charge_confirmUser'
          },
          {
            headerName: '航线负责人',
            field: 'job_planner'
          },
          {
            headerName: '开票日期',
            field: 'invoice_invoiceDate'
          },
          {
            headerName: '发票号码',
            field: 'charge_invoiceNo'
          },
          {
            headerName: '开票抬头',
            field: 'invoice_title'
          },
          {
            headerName: '是否需要开票',
            field: 'charge_needInvoice'
          },
          {
            headerName: '确认备注',
            field: 'charge_confirmRemarks'
          },
          {
            headerName: '销账日期',
            field: 'charge_clearingDate'
          },
          {
            headerName: '业务状态',
            field: 'job_jobState'
          },
          {
            headerName: '自定义字段1',
            field: 'job_userDefinedField1'
          },
          {
            headerName: '自定义字段2',
            field: 'job_userDefinedField2'
          },
          {
            headerName: '自定义字段3',
            field: 'job_userDefinedField3'
          },
          {
            headerName: '收付日期',
            field: 'charge_payReceiveDate'
          },
          {
            headerName: '销售部门',
            field: 'job.salesDepartment'
          }
        ],
        rowData: [{ job_jobNo: '12345' }]
      },
      jobGrid: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false
        },
        columnDefs: [
          {
            headerName: '', width: 55, checkboxSelection: true,
            sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true
          },
          {
            headerName: '业务编号',
            field: 'job_jobNo',
            cellRenderer: params => {
              const methodPath = this.documentManage.getPath('toSearchTemplate')
              return `<a href="/" style="color:#0052cc;">${params.value}</a>
                <i class="el-icon-search" onclick="${methodPath}('${params.data.jobNo}')" style="color:#46a6ff;cursor:pointer"/>`
            }
          },
          {
            headerName: '主单号',
            field: 'job_mbl'
          },
          {
            headerName: '委托单位',
            field: 'job_customerId'
          },
          {
            headerName: '结算对象',
            field: 'charge_accountId'
          },
          {
            headerName: '承运人',
            field: 'job_carrierId'
          },
          {
            headerName: 'SONO',
            field: 'job_soNo'
          },
          {
            headerName: '海外客服',
            field: 'job_overseaOp'
          },
          {
            headerName: '业务类型',
            field: 'job_lob'
          },
          {
            headerName: '业务日期',
            field: 'job_businessDate'
          },
          {
            headerName: '船名航次',
            field: 'job_vessel'
          },
          {
            headerName: '起运港',
            field: 'job_loadingPortCode'
          },
          {
            headerName: '目的港',
            field: 'job_destinationPortCode'
          },
          {
            headerName: '操作',
            field: 'job_op'
          },
          {
            headerName: '销售',
            field: 'job_sales'
          },
          {
            headerName: '已计提',
            field: 'job_provisioned'
          },
          {
            headerName: '币种',
            field: 'charge_currency'
          },
          {
            headerName: '含税价',
            field: 'charge_amount'
          },
          {
            headerName: '自定义字段1',
            field: 'job_userDefinedField1'
          },
          {
            headerName: '自定义字段2',
            field: 'job_userDefinedField2'
          },
          {
            headerName: '自定义字段3',
            field: 'job_userDefinedField3'
          }
        ],
        rowData: [{ job_jobNo: '12345' }]
      },
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: new SeaExportJob(),
        category: 'JOBLIST',
        data: {
          JOB_UUID: [],
          LOB: 'SE'
        }
      }
    }
  },
  computed: {
    title() {
      return this.paramsFinal.mode === 0 ? this.$t('CargoMsg.Cargo_ChooseFee') : this.$t('CargoMsg.Cargo_CreatePaymentRequestChooseFees')
    },
    paramsFinal() {
      const defaultParams = {
        mode: 0
      }
      return Object.assign(defaultParams, this.params)
    }
  },
  watch: {
    visible(newVal, oldVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal, oldVal) {
      this.$emit('update:visible', newVal)
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('toSearchTemplate', function(value) {
      context.toSearchTemplate(value)
    })
  },
  methods: {
    fetchData() {
      // todo 加载列表数据
      const rowData = [
        { job_jobNo: '12345' }
      ]
      switch (this.searchConditions.makeInvoiceMethod) {
        case 1: this.chargeGrid.rowData = rowData
          break
        case 2: this.jobGrid.rowData = rowData
          break
      }
    },
    confirm() {
      const self = this
      getGridSelectedIds(this.getGridOptions()).then(ids => {
        if (ids.length < 1) {
          self.$message.error(self.$t('common.tips.hasOneAtleast'))
        } else {
          this.$emit('selected', getGridSelected(this.getGridOptions())[0])
          this.innerVisible = false
        }
      })
    },
    toNext() {
      const self = this
      getGridSelectedIds(this.getGridOptions()).then(ids => {
        if (ids.length < 1) {
          self.$message.error(self.$t('common.tips.hasOneAtleast'))
        } else {
          this.$emit('next', getGridSelected(this.getGridOptions())[0])
        }
      })
    },
    // 【业务编号】列单元格中搜索图标点击触发事件
    toSearchTemplate(value) {
      // todo: 需要根据value装配this.templateSelectorDialog中相关内容
      const self = this
      if (!value) {
        self.$message.warning(`没有找到${value}对应的打印模板`)
      } else {
        this.templateSelectorDialog.data.JOB_UUID = [value]
        this.templateSelectorDialog.visible = true
      }
    },
    // 获取cargo-ag-grid表格组件的gridOptions
    getGridOptions() {
      let gridOptions
      switch (this.searchConditions.queryMode) {
        case 1: gridOptions = this.chargeGrid.gridOptions
          break
        case 2: gridOptions = this.jobGrid.gridOptions
          break
      }
      return gridOptions
    }
  }
}
</script>

<style lang="scss">
.charge-selector-dialog {
  .el-dialog__body {
    padding: 0 !important;
  }
  .el-scrollbar__wrap {
    overflow-x: auto;
  }
  .dense-radio-group {
    .el-form-item {
      margin-bottom: 0 !important;
      .el-form-item__content {
        vertical-align: middle;
      }
    }
    .el-radio {
      margin-right: 8px !important;
      .el-radio__label {
        padding-left: 5px!important;
      }
    }
  }
  .total-detail-popover {
    display: flex;
    align-items: center;
    justify-content: center;
    >span {
      padding-right: 6px;
    }
  }
}
</style>
